module.exports = __webpack_public_path__ + "img/w-03.31d194f4.svg";